/**
 * Динамический счетчик посетителей
 */
function initVisitorCounter() {
  const counterElement = document.getElementById('live-visitor-count');
  if (!counterElement) return;

  // Начальное случайное число при загрузке
  let currentCount = Math.floor(Math.random() * (1800 - 1300 + 1)) + 1300;
  counterElement.innerText = currentCount;

  // Функция для имитации активности
  setInterval(() => {
    const change = Math.floor(Math.random() * 7) - 3; // от -3 до +3
    currentCount += change;

    // Ограничитель, чтобы число не ушло в минус или слишком низко
    if (currentCount < 1100) currentCount += 15;
    if (currentCount > 2500) currentCount -= 15;

    counterElement.innerText = currentCount;
  }, 4000);
}

// Запуск после полной загрузки DOM
document.addEventListener('DOMContentLoaded', initVisitorCounter);

document.addEventListener('shopify:section:load', initVisitorCounter);